import { tierReasonAPI } from "@/views/TierReason/services/api";

export const getReasons = async () => {
  try {
    const res = await tierReasonAPI.getReasons();
    return res?.data;
  } catch (e) {}
};

export const getReason = async (reason_id) => {
  try {
    const res = await tierReasonAPI.getReason(reason_id);
    return res?.data;
  } catch (e) {}
};

export const insertReason = async (data) => {
  try {
    const res = await tierReasonAPI.insertReason(data);
    return res;
  } catch (e) {}
};

export const updateReason = async (data) => {
  try {
    const res = await tierReasonAPI.updateReason(data);
    return res;
  } catch (e) {}
};

export const deleteReason = async (reason_id) => {
  try {
    const res = await tierReasonAPI.deleteReason(reason_id);
    return res;
  } catch (e) {}
};

